import {
  SDHW_GET_LIST,
  SDHW_GET_LIST_SUCCESS,
  SDHW_GET_LIST_FAILURE,
  SDHW_GET_DATA,
  SDHW_GET_DATA_SUCCESS,
  SDHW_GET_DATA_FAILURE,
  SDHW_GET_READER_STATUS,
  SDHW_GET_READER_STATUS_SUCCESS,
  SDHW_GET_READER_STATUS_FAILURE,
  SDHW_TEST_READER,
  SDHW_TEST_READER_SUCCESS,
  SDHW_TEST_READER_FAILURE,
} from "./actionType";

const initState = {
  list: [],
  listLoading: false,
  listError: null,

  data: null,
  dataLoading: false,
  dataError: null,

  // Reader status + test-probe results are keyed by SystemDevice Id so the list
  // page can check several readers independently without clobbering each other.
  readerStatusById: {},
  readerStatusLoadingById: {},

  testResultById: {},
  testLoadingById: {},
};

const SystemDeviceHardware = (state = initState, { type, payload }) => {
  switch (type) {
    case SDHW_GET_LIST:
      return { ...state, listLoading: true, listError: null };
    case SDHW_GET_LIST_SUCCESS:
      return { ...state, list: payload, listLoading: false, listError: null };
    case SDHW_GET_LIST_FAILURE:
      return { ...state, list: [], listLoading: false, listError: payload };

    case SDHW_GET_DATA:
      return { ...state, dataLoading: true, dataError: null };
    case SDHW_GET_DATA_SUCCESS:
      return { ...state, data: payload, dataLoading: false, dataError: null };
    case SDHW_GET_DATA_FAILURE:
      return { ...state, data: null, dataLoading: false, dataError: payload };

    case SDHW_GET_READER_STATUS:
      return {
        ...state,
        readerStatusLoadingById: {
          ...state.readerStatusLoadingById,
          [payload?.id]: true,
        },
      };
    case SDHW_GET_READER_STATUS_SUCCESS:
      return {
        ...state,
        readerStatusById: {
          ...state.readerStatusById,
          [payload?.id]: payload?.response,
        },
        readerStatusLoadingById: {
          ...state.readerStatusLoadingById,
          [payload?.id]: false,
        },
      };
    case SDHW_GET_READER_STATUS_FAILURE:
      return {
        ...state,
        readerStatusLoadingById: {
          ...state.readerStatusLoadingById,
          [payload?.id]: false,
        },
      };

    case SDHW_TEST_READER:
      return {
        ...state,
        testLoadingById: {
          ...state.testLoadingById,
          [payload?.id]: true,
        },
      };
    case SDHW_TEST_READER_SUCCESS:
      return {
        ...state,
        testResultById: {
          ...state.testResultById,
          [payload?.id]: payload?.response,
        },
        testLoadingById: {
          ...state.testLoadingById,
          [payload?.id]: false,
        },
      };
    case SDHW_TEST_READER_FAILURE:
      return {
        ...state,
        testLoadingById: {
          ...state.testLoadingById,
          [payload?.id]: false,
        },
      };

    default:
      return state;
  }
};

export default SystemDeviceHardware;
